/**
 * The sentence a Settings save shows for a failed request (Asana 1219424036699792).
 *
 * The backend's class-validator 400 reads "Invalid body, check 'errors' property
 * for more info." with the real reason under `errors[].constraints`; the other
 * errors (409 taken username, 500) carry a human sentence in `message`. This
 * prefers the human sentence, falls through to the first constraint text, and
 * never returns the "Invalid body" line itself.
 */
const isGenericValidationMessage = (message: string): boolean =>
  /invalid body/i.test(message) || /'errors' property/i.test(message);

export const settingsErrorMessage = (err: unknown, fallback: string): string => {
  const data = (err as { data?: unknown } | null | undefined)?.data as
    | { message?: unknown; errors?: unknown }
    | undefined;
  const rawMessage = data?.message;
  const message = typeof rawMessage === 'string' ? rawMessage.trim() : '';
  if (message && !isGenericValidationMessage(message)) return message;

  const rawErrors = data?.errors;
  const errors: unknown[] = Array.isArray(rawErrors) ? rawErrors : [];
  for (const entry of errors) {
    const constraints = (entry as { constraints?: unknown } | null)?.constraints;
    if (constraints && typeof constraints === 'object') {
      const text = Object.values(constraints as Record<string, unknown>).find((v) => typeof v === 'string' && v.trim());
      if (typeof text === 'string') return text.trim();
    }
  }
  return fallback;
};

export default settingsErrorMessage;
